import React, { useRef } from 'react';

type YesNoItemProps = { name: string; label: string };

const YesNoItem: React.FC<YesNoItemProps> = ({ name, label }) => {
  const idYes = `${name}-yes`;
  const idNo = `${name}-no`;
  return (
    <div className="yesno-item">
      <span className="lbl">{label}</span>
      <label htmlFor={idYes}>
        <input id={idYes} type="radio" name={name} value="yes" /> Yes
      </label>
      <label htmlFor={idNo}>
        <input id={idNo} type="radio" name={name} value="no" /> No
      </label>
    </div>
  );
};

const PastMedicalHistoryForm: React.FC = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const clear = () => formRef.current?.reset();

  const hasBabyHad = [
    'Blood anemia (Iron Deficiency, Sickle Cell, Thalassemia)',
    'Blood Transfusions',
    'Chicken Pox (Varicella)',
    'Contusions',
    'Convulsions',
    'Fractures',
    'German Measles (Rubella)',
    'Hospitalizations',
    'Measles (Rubeola)',
    'Meningitis',
    'Mumps',
    'Operations',
    'Poison Ingestion',
    'Other serious medical illnesses',
    'Is your baby currently taking any medications, vitamins or herbs?',
    'Reaction to medication or food (allergy)',
    'Any chronic or recurring pain?',
  ];

  const sectionItems: Array<{ title: string; items: string[] }> = [
    { title: 'Eyes', items: ['Any visual problems?', 'Do eyes look crossed?', 'Does the child wear eyeglasses?'] },
    { title: 'Ears', items: ['Any hearing problems?', 'Three or more ear infections?'] },
    { title: 'Nose', items: ['Does the baby have frequent attacks of sneezing or rubbing his/her nose?', 'Has the baby had frequent nose bleeds?'] },
    { title: 'Throat', items: ['Does your baby have three or more strep throat infections per year?'] },
    { title: 'Heart', items: ['A heart murmur?', 'Heart defect?', 'High blood pressure?'] },
    { title: 'Lungs', items: ['Asthma / Wheezing?', 'Bronchitis or Pneumonia?', 'Chronic Cough?'] },
    { title: 'Abdomen', items: ['Blood in bowel movement?', 'Difficulty with appetite or eating?', 'Frequent abdominal pain?', 'Frequent vomiting or diarrhea?', 'Jaundice?', 'Marked weight loss?'] },
    { title: 'Kidney', items: ['Does your child ever complain of burning or frequency of urination?', 'Does your child wet the bed?', 'Has there ever been blood in the urine?', 'Has your child ever had a urinary tract infection?'] },
    { title: 'Skin', items: ['Acne?', 'Any sensitivity or allergy?', 'Eczema or atopic dermatitis?'] },
    { title: 'Extremities', items: ['Weakness or paralysis of arms or legs?', 'Persistent limp?', 'Every worn corrective shoes or braces?'] },
    { title: 'Neurological', items: ['Breath holding?', 'Convulsions or Seizures?', 'Dizziness?', 'Fainting?', 'Frequent headaches?'] },
    { title: 'Is your child:', items: ['Impulsive?', 'Lacking in self-control?', 'Overactive?'] },
    { title: 'Does your child have problems with:', items: ['Attending school?', 'Attention span?', 'Learning?', 'Mood?', 'Parents?', 'Siblings?', 'Peers?', 'Sleep?'] },
  ];

  return (
    <form ref={formRef} className="family-form">
      <div className="section-title">Has the baby had:</div>
      <div className="yesno-list two">
        {hasBabyHad.map((q, i) => (
          <YesNoItem key={q} name={`had_${i + 1}`} label={`${i + 1}. ${q}`} />
        ))}
      </div>

      {sectionItems.map((sec, si) => (
        <div key={sec.title} style={{ marginTop: 12 }}>
          <div className="section-title">{sec.title}</div>
          <div className={sec.items.length > 1 ? 'yesno-list two' : 'yesno-list one'}>
            {sec.items.map((q, qi) => (
              <YesNoItem key={q} name={`sec_${si}_${qi}`} label={`${qi + 1}. ${q}`} />
            ))}
          </div>
        </div>
      ))}

      <div style={{ marginTop: 12 }}>
        <div className="section-title">Are there concerns about physical, sexual or emotional abuse?</div>
        <div className="yesno-list one">
          <YesNoItem name="abuse_concerns" label="" />
        </div>
      </div>

      <div style={{ marginTop: 12 }}>
        <div className="section-title">Any other concerns you would like to discuss?</div>
        <textarea style={{ width: '100%', minHeight: 100, padding: 10, borderRadius: 6, border: '1px solid #e0e6ef', background: '#fff' }} placeholder="Click here to type" />
      </div>

      <div className="form-actions">
        <button type="button" className="btn-clear" onClick={clear}>Clear</button>
      </div>
    </form>
  );
};

export default PastMedicalHistoryForm;


